import { Injectable } from '@angular/core';
import { UnitQuantity } from '../form-controls/unit-quantity/unit-quantity.control';
import { Action, ActionAlert, ActionAlertTestCondition } from '../types/aggregate-graph.types';

export type ActionAlertValue = UnitQuantity | number | null;

@Injectable({
	providedIn: 'root'
})
export class SheetActionAlertService {

	constructor() {
	}

	getSign(alertCondition: ActionAlertTestCondition): string {
		switch (alertCondition) {
			case ActionAlertTestCondition.LessThan:
				return '<';
			case ActionAlertTestCondition.LessThanOrEqualTo:
				return '≤';
			case ActionAlertTestCondition.EqualTo:
				return '=';
			case ActionAlertTestCondition.GreaterThanOrEqualTo:
				return '≥';
			case ActionAlertTestCondition.GreaterThan:
				return '>';
		}
	}

	getTriggeredAlertsForAction(action: Action | any, alerts: ActionAlert[]): ActionAlert[] {
		return alerts
			.filter(a => typeof action[a.actionPropertyName] === 'number' || typeof action[a.actionPropertyName]?.quantity === 'number')
			.filter(a => this.valueTriggersAlert(typeof action[a.actionPropertyName] === 'number' ? action[a.actionPropertyName] : action[a.actionPropertyName].quantity, a));
	}

	getTriggeredAlertsForControl(value: number | null, controlName: string, alerts: ActionAlert[]): ActionAlert[] {
		if (value === null) return [];
		return alerts.filter(alert => alert.actionPropertyName === controlName && this.valueTriggersAlert(value, alert));
	}

	private valueTriggersAlert(value: number, alert: ActionAlert): boolean {
		switch (alert.alertCondition) {
			case ActionAlertTestCondition.LessThan:
				return value < alert.valueToCompareAgainst;
			case ActionAlertTestCondition.LessThanOrEqualTo:
				return value <= alert.valueToCompareAgainst;
			case ActionAlertTestCondition.EqualTo:
				return value === alert.valueToCompareAgainst;
			case ActionAlertTestCondition.GreaterThanOrEqualTo:
				return value >= alert.valueToCompareAgainst;
			case ActionAlertTestCondition.GreaterThan:
				return value > alert.valueToCompareAgainst;
		}
	}
}